/**
 * Free Difford's Easy Jigger gift (Christmas 2026)
 *
 * Adds a tick box to the cart page and cart drawer once the cart, EXCLUDING the
 * Easy Jigger, reaches £99. Ticking adds one Easy Jigger flagged as the free gift;
 * the scheduled automatic discount "Christmas: free Easy Jigger when you spend £99"
 * makes it free at checkout. Below £99 a "spend £X more" line shows instead, and a
 * gift jigger already in the cart is removed automatically.
 *
 * PREVIEW_MODE: true shows the box whatever the date, for testing on the
 * unpublished theme. Set to false before publishing so it only appears from
 * 27 November to 21 December 2026.
 */
(function () {
  const PREVIEW_MODE = false;
  const JIGGER_VARIANT_ID = 55509767684445;
  const THRESHOLD = 9900; // pence
  const OFFER_START = Date.parse('2026-11-27T00:00:00Z');
  const OFFER_END = Date.parse('2026-12-21T23:59:59Z');
  const ANCHORS = '.proceed-to-checkout, .cart-drawer-buttons';

  let busy = false;
  let pending = null;
  const attemptedRemovals = new Set();

  function offerLive() {
    if (PREVIEW_MODE) return true;
    const now = Date.now();
    return now >= OFFER_START && now <= OFFER_END;
  }

  function formatMoney(pence, currency) {
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency || 'GBP' }).format(pence / 100);
    } catch (e) {
      return '£' + (pence / 100).toFixed(2);
    }
  }

  function post(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    });
  }

  function refreshCarts() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.refresh === 'function') drawer.refresh();
    if (document.getElementById('Cart')) document.dispatchEvent(new CustomEvent('cart:refresh'));
    scheduleRender();
  }

  function run(action) {
    if (busy) return;
    busy = true;
    document.querySelectorAll('.free-jigger-gift').forEach((el) => el.classList.add('is-loading'));
    action()
      .catch(() => {})
      .finally(() => {
        busy = false;
        refreshCarts();
      });
  }

  function addGift() {
    return post(`${theme.routes.cart_add_url}.js`, {
      items: [{ id: JIGGER_VARIANT_ID, quantity: 1, properties: { _free_gift: 'yes' } }]
    });
  }

  function removeGift(key) {
    return post(`${theme.routes.cart_change_url}.js`, { id: key, quantity: 0 });
  }

  function buildBox(state) {
    const box = document.createElement('div');
    box.className = 'free-jigger-gift';
    if (state.qualifies) {
      box.innerHTML =
        '<label class="free-jigger-gift__label">' +
        '<input type="checkbox" class="free-jigger-gift__checkbox"' + (state.giftKey ? ' checked' : '') + '>' +
        "<span>Claim your free Difford's Easy Jigger with this order</span>" +
        '</label>';
      box.querySelector('input').addEventListener('change', (event) => {
        if (event.target.checked && !state.giftKey) run(addGift);
        else if (!event.target.checked && state.giftKey) run(() => removeGift(state.giftKey));
      });
    } else {
      box.innerHTML =
        '<p class="free-jigger-gift__nudge">Spend ' +
        formatMoney(state.remaining, state.currency) +
        " more to claim a free Difford's Easy Jigger.</p>";
    }
    return box;
  }

  function render(cart) {
    document.querySelectorAll('.free-jigger-gift').forEach((el) => el.remove());
    if (!offerLive() || !cart || cart.item_count === 0) return;

    let qualifying = 0;
    let giftKey = '';
    cart.items.forEach((item) => {
      if (item.variant_id === JIGGER_VARIANT_ID) {
        if (item.properties && item.properties._free_gift === 'yes') giftKey = item.key;
      } else {
        qualifying += item.original_line_price;
      }
    });

    const state = {
      qualifies: qualifying >= THRESHOLD,
      remaining: THRESHOLD - qualifying,
      giftKey: giftKey,
      currency: cart.currency
    };

    // Cart has dropped below £99 with a gift jigger in it: take the gift out.
    if (!state.qualifies && giftKey && !attemptedRemovals.has(giftKey)) {
      attemptedRemovals.add(giftKey);
      run(() => removeGift(giftKey));
      return;
    }

    document.querySelectorAll(ANCHORS).forEach((anchor) => {
      anchor.parentNode.insertBefore(buildBox(state), anchor);
    });
  }

  function fetchAndRender() {
    fetch(`${theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then(render)
      .catch(() => {});
  }

  function scheduleRender() {
    clearTimeout(pending);
    pending = setTimeout(fetchAndRender, 200);
  }

  // Re-draw whenever the theme re-renders the cart page or drawer.
  function anchorMissingBox() {
    return Array.from(document.querySelectorAll(ANCHORS)).some((anchor) => {
      const prev = anchor.previousElementSibling;
      return !prev || !prev.classList.contains('free-jigger-gift');
    });
  }

  function init() {
    if (!offerLive()) return;
    fetchAndRender();
    new MutationObserver(() => {
      if (!busy && anchorMissingBox()) scheduleRender();
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('line-item:change:end', scheduleRender);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
